import Intercom, { shutdown as intercomShutdown, update as intercomUpdate } from "@intercom/messenger-js-sdk"

const isIntercomVisible = ref(false)
export function useIntercom() {
  /**
   * Initializes Intercom messenger with app ID and optional user data
   * @param user - Optional user data to initialize Intercom with
   */
  function initIntercom(user?: Nullable<Partial<User>>) {
    const config = useConfig()
    const appId = config.NUXT_PUBLIC_INTERCOM_APP_ID

    if (!appId) {
      return
    }

    Intercom({
      app_id: appId,
      hide_default_launcher: false,
    })

    isIntercomVisible.value = true

    // Update the intercom with the user if it exists
    user && updateIntercomWithUser(user)
  }

  /**
   * Updates Intercom with user data
   * @param user - User data to update Intercom with
   */
  function updateIntercomWithUser(user?: Nullable<Partial<User>>) {
    intercomUpdate({
      email: user?.email,
      user_hash: user?.hash,
    })
  }

  /** Hides the Intercom messenger and shuts it down */
  function hideIntercom() {
    isIntercomVisible.value = false
    intercomShutdown()
  }

  /** Resets Intercom by hiding and reinitializing it */
  function resetIntercom() {
    hideIntercom()
    initIntercom()
  }

  return {
    initIntercom,
    resetIntercom,
    hideIntercom,
    updateIntercomWithUser,
    isIntercomVisible,
  }
}
